<template>
  <div class="list">
    <div class="list-filter">
      <el-form :inline="true" :model="queryEntity" class="demo-form-inline">
        <el-form-item label="商品编码">
          <el-input size="medium" v-model="queryEntity.code" placeholder="商品编码"></el-input>
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input size="medium" v-model="queryEntity.name" placeholder="商品名称"></el-input>
        </el-form-item>
        <el-form-item label="商品分类">
          <el-select clearable v-model="queryEntity.categoryId" size="medium" placeholder="全部商品分类">
            <el-option v-for="item in productCategoryList" :key="item.id" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select class="list-filter-state" clearable v-model="queryEntity.state" size="medium" placeholder="全部状态">
            <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="list-btn-select" size="small" type="primary" @click="selectList">查询</el-button>
          <el-button class="list-btn-reset" size="small" @click="resetSelect">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="list-tool cf">
      <div class="fl">
        <el-button class="list-btn" size="small" type="primary" :disabled="disableAuth('add')" @click="add">新增</el-button>
        <el-button class="list-btn" size="small" type="danger" :disabled="disableAuth('delete')" @click="deleteList">批量删除</el-button>
      </div>
      <div class="fr">
        <el-button class="list-btn" size="small" type="primary" @click="put">批量上架</el-button>
        <el-button class="list-btn list-btn-last" size="small" type="warning" @click="out">批量下架</el-button>
      </div>
    </div>
    <div class="list-table">
      <el-table :data="dataList" :header-cell-class-name="headerCellClass" :max-height="tableHeight" stripe @selection-change="handleSelectionChange" size="medium">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="no" label="序号" width="50" fixed> </el-table-column>
        <el-table-column prop="code" label="商品编码" width="120" fixed> </el-table-column>
        <el-table-column prop="name" label="商品名称" fixed> </el-table-column>
        <el-table-column prop="productCategory.name" label="商品分类" width="180"> </el-table-column>
        <el-table-column prop="cas" label="CAS" width="120"> </el-table-column>
        <el-table-column prop="spec" label="规格" width="120"> </el-table-column>
        <el-table-column prop="platformPrice" label="平台价格" width="100"> </el-table-column>
        <el-table-column prop="salePrice" label="销售价格" width="100"> </el-table-column>
        <el-table-column prop="platformState" label="平台状态" width="100"> </el-table-column>
        <el-table-column prop="stateName" label="状态" width="100"> </el-table-column>
        <el-table-column prop="validityDate" label="有效期" width="180"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="210">
          <template #default="scope">
            <el-button type="primary" size="mini" :disabled="disableAuth('view')" @click="view(scope)">查看</el-button>
            <el-button type="success" size="mini" :disabled="disableAuth('modify')" @click="modify(scope)">修改</el-button>
            <el-button type="danger" size="mini" :disabled="disableAuth('delete')" @click="deleteItem(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="list-pager">
      <el-pagination class="list-pager-inner" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" v-model:currentPage="queryParam.pager.pageIndex" v-model:page-size="queryParam.pager.pageSize" :total="queryParam.pager.total" layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script lang="ts">
import { Product, ProductCategory } from "@/script/apps/shop/entity/ShopEntity";
import { DictUtil } from "@/script/core/Dict";
import { ElLoading, ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { ProductService } from "@/script/apps/shop/service/ProductService";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { Dict } from "@/script/apps/system/entity/SystemEntity";
import { ProductCategoryService } from "@/script/apps/shop/service/ProductCategoryService";

@Options({})
export default class ProductList extends BaseList {
  private queryEntity: Product = {};

  private dataList: Product[] = [];

  private productCategoryList: ProductCategory[] = [];

  private productService = new ProductService();

 public initData(): ServiceContext {   
    const data = ServiceFactory.build(
      "biz_shop_product",
      "/shop/product",
      "/shop/product",
      this.productService
    );
    data.statesName = "product-state";
    return data;
  }

  public initQueryEntity() {
    const self = this;
    this.queryEntity = {
      code: "",
      name: "",
      state: undefined,
      categoryId: undefined,
    };
    return this.queryEntity;
  }

  
  protected initOptions() {
    super.initOptions();
    const productCategoryService = new ProductCategoryService();
    productCategoryService.loadProductCategorys((data: any) => {
      this.productCategoryList = data;
    });
  }

  public afterLoadList(data: any): void {
    const products: Product[] = data.list as Product[];   
    this.dataList = products;
  }

  private put() {
    if (this.selectedList.length === 0) {
      ElMessage.error("请选择要上架的商品！");
      return;
    }
    const ids: number[] = [];
    this.selectedList.forEach((item) => {
      ids.push(item.id!);
    });

    const loading = ElLoading.service({
      lock: true,
      text: "上架执行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.productService.put(ids).then(
      (result: any) => {
        loading.close();
        ElMessage({ type: "success", message: result.message });
        this.loadList();
      },
      (error: Error) => {
        loading.close();
        ElMessage.error("上架失败，失败原因：" + error.message);
      }
    );
  }

  private out() {
    if (this.selectedList.length === 0) {
      ElMessage.error("请选择要下架的商品！");
      return;
    }
    const ids: number[] = [];
    this.selectedList.forEach((item) => {
      ids.push(item.id!);
    });

    const loading = ElLoading.service({
      lock: true,
      text: "下架执行中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.productService.out(ids).then(
      (result: any) => {
        loading.close();
        ElMessage({ type: "success", message: result.message });
        this.loadList();
      },
      (error: Error) => {
        loading.close();
        ElMessage.error("下架失败，失败原因：" + error.message);
      }
    );
  }
}
</script>
